import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-extrabold text-orange-400 mb-4">
            Terms of Service
          </h1>
          <p className="text-gray-300 text-sm">
            Last Updated: December 18, 2024
          </p>
        </div>

        {/* Content Card */}
        <div className="bg-gray-800 rounded-lg shadow-lg p-8 mb-8">
          <div className="prose prose-invert max-w-none">
            
            {/* Legal Notice */}
            <div className="bg-orange-900 border border-orange-700 text-orange-200 px-4 py-3 rounded-md mb-8">
              <p className="text-sm font-medium">
                <strong>Important Legal Notice:</strong> This is a template document provided for reference purposes only. 
                This content is not a substitute for professional legal advice. You should consult with qualified legal 
                professionals before using this content in any production environment.
              </p>
            </div>

            {/* 1. Acceptance of Terms */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">1. Acceptance of Terms</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  By accessing and using Bitcoin Wealth Builder (the "Service"), you accept and agree to be bound by 
                  the terms and provision of this agreement. If you do not agree to these Terms of Service, 
                  please do not use the Service.
                </p>
                <p>
                  These Terms of Service may be updated from time to time without notice. Your continued use of the 
                  Service after any such changes constitutes your acceptance of the new Terms of Service.
                </p>
              </div>
            </section>

            {/* 2. Description of Service */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">2. Description of Service</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Bitcoin Wealth Builder is a web-based application that provides financial calculators and planning 
                  tools related to Bitcoin investments. The Service includes various calculators for interest 
                  calculations, retirement planning, loan-to-value ratios, and financial goal planning.
                </p>
                <p>
                  The Service is provided for educational and informational purposes only and is not intended as 
                  professional financial, investment, or tax advice.
                </p>
              </div>
            </section>

            {/* 3. Important Disclaimers */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">3. Important Disclaimers</h2>
              <div className="text-gray-300 space-y-4">
                <div className="bg-red-900 border border-red-700 text-red-200 px-4 py-3 rounded-md">
                  <p className="font-semibold text-sm">
                    NOT FINANCIAL ADVICE: The information provided by this Service is for educational purposes only 
                    and does not constitute financial, investment, tax, or legal advice. You should not rely on this 
                    information as a substitute for professional financial advice tailored to your specific situation.
                  </p>
                </div>
                <p>
                  All calculations, projections, and estimates provided by the Service are hypothetical and based on 
                  assumptions that may not reflect actual market conditions or personal circumstances. Past performance 
                  does not guarantee future results.
                </p>
                <p>
                  Cryptocurrency investments, including Bitcoin, are subject to high volatility and risk. You may lose 
                  some or all of your investment. Never invest more than you can afford to lose.
                </p>
              </div>
            </section>

            {/* 4. User Responsibilities */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">4. User Responsibilities</h2>
              <div className="text-gray-300 space-y-4">
                <p>By using the Service, you agree to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide accurate and complete information when creating an account</li>
                  <li>Maintain the security of your account credentials</li>
                  <li>Use the Service only for lawful purposes and in accordance with these Terms</li>
                  <li>Not attempt to gain unauthorized access to the Service or its systems</li>
                  <li>Not use the Service to transmit harmful, offensive, or illegal content</li>
                  <li>Understand that any financial decisions you make are your sole responsibility</li>
                </ul>
              </div>
            </section>

            {/* 5. Intellectual Property */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">5. Intellectual Property</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  The Service and its original content, features, and functionality are owned by the operators of 
                  Bitcoin Wealth Builder and are protected by international copyright, trademark, patent, trade secret, 
                  and other intellectual property or proprietary rights laws.
                </p>
                <p>
                  You may not copy, modify, distribute, sell, or lease any part of our Service or included software, 
                  nor may you reverse engineer or attempt to extract the source code of that software.
                </p>
              </div>
            </section>

            {/* 6. Limitation of Liability */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">6. Limitation of Liability</h2>
              <div className="text-gray-300 space-y-4">
                <div className="bg-yellow-900 border border-yellow-700 text-yellow-200 px-4 py-3 rounded-md">
                  <p className="text-sm font-medium">
                    TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL BITCOIN WEALTH BUILDER, ITS AFFILIATES, 
                    OR SERVICE PROVIDERS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE 
                    DAMAGES, INCLUDING WITHOUT LIMITATION LOSS OF PROFITS, DATA, USE, OR GOODWILL.
                  </p>
                </div>
                <p>
                  We make no warranties, expressed or implied, regarding the accuracy, reliability, or completeness of 
                  the information provided through the Service. Your use of the Service is at your own risk.
                </p>
              </div>
            </section>

            {/* 7. Account Termination */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">7. Account Termination</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  We may terminate or suspend your account immediately, without prior notice or liability, for any 
                  reason whatsoever, including without limitation if you breach the Terms of Service.
                </p>
                <p>
                  Upon termination, your right to use the Service will cease immediately. If you wish to terminate 
                  your account, you may simply discontinue using the Service.
                </p>
              </div>
            </section>

            {/* 8. Privacy */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">8. Privacy</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  Your privacy is important to us. Please review our Privacy Policy, which also governs your use of 
                  the Service, to understand our practices regarding the collection, use, and disclosure of your information.
                </p>
              </div>
            </section>

            {/* 9. Governing Law */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">9. Governing Law</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  These Terms shall be interpreted and governed by the laws of the jurisdiction in which the Service 
                  operates, without regard to its conflict of law provisions. Our failure to enforce any right or 
                  provision of these Terms will not be considered a waiver of those rights.
                </p>
              </div>
            </section>

            {/* 10. Changes to Terms */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">10. Changes to Terms</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a 
                  revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
                </p>
                <p>
                  By continuing to access or use our Service after those revisions become effective, you agree to be 
                  bound by the revised terms.
                </p>
              </div>
            </section>

            {/* 11. Contact Information */}
            <section className="mb-8">
              <h2 className="text-xl font-bold text-orange-400 mb-4">11. Contact Information</h2>
              <div className="text-gray-300 space-y-4">
                <p>
                  If you have any questions about these Terms of Service, please contact us through the appropriate 
                  channels provided in the application.
                </p>
              </div>
            </section>
          </div>
        </div>

        {/* Navigation */}
        <div className="text-center space-y-4">
          <button
            onClick={() => navigate('/privacy')}
            className="text-orange-400 hover:text-orange-300 text-sm font-medium transition-colors duration-200 mr-6"
          >
            View Privacy Policy →
          </button>
          <button
            onClick={() => navigate('/')}
            className="text-gray-400 hover:text-gray-300 text-sm transition-colors duration-200"
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;